import { RouteRecordRaw } from "vue-router";
import { ROLES_AND_PERMISSION_ON_ROUTES } from "@/core/configs/rolesAndPermissionsMappingOnRoutes";

const routes: Array<RouteRecordRaw> = [
  {
    path: "",
    name: "403",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.Error403.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.Error403.PERMISSIONS,
    },
    component: () => import("../views/Error403.vue"),
  },
];

export default routes;
